import { CardContainer, FormLayout, SectionHeadingSkeleton } from '@/_containers';
import PhoneNumberLoading from '@/_containers/inputs/phone-number/loading';
import { RichTextLoader } from '@/_containers/inputs/rich-text';

export default function Loading() {
  return (
    <>
      <CardContainer>
        <SectionHeadingSkeleton />

        <PhoneNumberLoading />
      </CardContainer>
      <CardContainer>
        <SectionHeadingSkeleton />

        <PhoneNumberLoading />
      </CardContainer>
      <CardContainer>
        <SectionHeadingSkeleton />
        <FormLayout>
          <RichTextLoader inline className="col-span-12" />
        </FormLayout>
      </CardContainer>
    </>
  );
}
